import { useCallback, useEffect, useRef, useState } from 'react'
import { flushSync } from 'react-dom'

import type { RecentItemInlineTitleEditHandle } from './RecentItemInlineTitleEdit'

export default function useBeginRecentItemRename(title: string | undefined, fallbackTitle: string) {
  const [isRenaming, setIsRenaming] = useState(false)
  const [displayTitle, setDisplayTitle] = useState(title?.trim() || fallbackTitle)
  const titleEditRef = useRef<RecentItemInlineTitleEditHandle>(null)

  useEffect(() => {
    setDisplayTitle(title?.trim() || fallbackTitle)
  }, [fallbackTitle, title])

  const beginRename = useCallback((closeMenu?: () => void) => {
    closeMenu?.()
    flushSync(() => {
      setIsRenaming(true)
    })
    titleEditRef.current?.focus()
  }, [])

  const handleRenamed = useCallback((name: string) => {
    setDisplayTitle(name)
  }, [])

  return {
    isRenaming,
    setIsRenaming,
    titleEditRef,
    beginRename,
    displayTitle,
    handleRenamed,
  }
}
